import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import '../../App.css';
import { Styles, StyleConstants } from '../../Styles';
import GreenGreyLightIcon from '../../components/GreenGreyLightIcon';
import GreenRedLightIcon from '../../components/GreenRedLightIcon';
import RedGreyLightIcon from '../../components/RedGreyLightIcon';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Decimal from 'decimal.js';

const CarVccSystemTab = (props) => {
    const { packet } = props;

    let openDoorsCommand = 0;
    let energencyStop = 0;
    let notReleasedBrake = 0;
    let couplingRelayNo1End = 0;
    let couplingRelayNo2End = 0;

    let brakeAirCompressorContractor = 0;
    let additionalEBPushbutton = 0;
    let passengerDoorLock = 0;
    let airCompressorTemperatureContact = 0;
    let airCompressorPressureSwitch = 0;
    let airCompressorThermalOverload = 0;

    if (packet.board3 !== null) {
        //packet.digital24V_digital: {command: '93', count: '00', ch1: '0' ... ch15: '0'}
        const digital24VFirstBin = packet.board3.digital24V.ch9 
                + packet.board3.digital24V.ch10 
                + packet.board3.digital24V.ch11
                + packet.board3.digital24V.ch12
                + packet.board3.digital24V.ch13
                + packet.board3.digital24V.ch14
                + packet.board3.digital24V.ch15;

        for (let i = digital24VFirstBin.length; i > -1; i--) {
            switch (i) {
                case 0:
                    openDoorsCommand = digital24VFirstBin.charAt(i);
                    break;
                case 1:
                    energencyStop = digital24VFirstBin.charAt(i);
                    break;
                case 2:
                    notReleasedBrake = digital24VFirstBin.charAt(i);
                    break;
                case 3:
                    couplingRelayNo1End = digital24VFirstBin.charAt(i);
                    break;
                case 4:
                    couplingRelayNo2End = digital24VFirstBin.charAt(i);
                    break;
            }
        }

        //packet.dryContact_digital: {command: '94', count: '00', ch1: '0' ... ch15: '0'}
        const dryContactFirstBin = packet.board3.dryContact.ch9
                + packet.board3.dryContact.ch10
                + packet.board3.dryContact.ch11
                + packet.board3.dryContact.ch12
                + packet.board3.dryContact.ch13
                + packet.board3.dryContact.ch14
                + packet.board3.dryContact.ch15;

        for (let i = dryContactFirstBin.length; i > -1; i--) {
            switch (i) {
                case 0:
                    brakeAirCompressorContractor = dryContactFirstBin.charAt(i);
                    break;
                case 1:
                    additionalEBPushbutton = dryContactFirstBin.charAt(i);
                    break;
                case 2:
                    passengerDoorLock = dryContactFirstBin.charAt(i);
                    break;
                case 3:
                    airCompressorTemperatureContact = dryContactFirstBin.charAt(i);
                    break;
                case 4:
                    airCompressorPressureSwitch = dryContactFirstBin.charAt(i);
                    break;
                case 5:
                    airCompressorThermalOverload = dryContactFirstBin.charAt(i);
                    break;
            }
        }
    }
    
    return (
        <>
            {(packet.board3 !== null) && (
                <TableContainer component={Paper}>
                    <Table size='small' sx={{ border: '3px solid ' + StyleConstants.borderColor }}>
                        <TableHead>
                            <TableRow sx={{ '& th': { color: '#FFFFFF', backgroundColor: StyleConstants.mainBgColor } }}>
                                <TableCell sx={Styles.carCell}>
                                    VCC Status of LRV
                                </TableCell>
                                <TableCell sx={{ ...Styles.carBorderCell, width: '200px' }}>
                                    Unit 1
                                </TableCell>

                                <TableCell sx={Styles.carBorderCell}>
                                    VCC Status of LRV
                                </TableCell>
                                <TableCell sx={{ ...Styles.carBorderCell, width: '200px' }}>
                                    Unit 1
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                <TableCell sx={Styles.carCell}>
                                    Not Released Brake
                                </TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    <RedGreyLightIcon onOffBit={notReleasedBrake} onLabel="Brake not released" offLabel="Brake released" />
                                </TableCell>

                                <TableCell sx={Styles.carBorderCell}>
                                    Speed Signal
                                </TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    <Stack direction="column">
                                        <Typography>
                                            Counter 1: {new Decimal(packet.board3.counter.speedSignal1).toFixed(1)}
                                        </Typography>
                                        <Typography>
                                            Counter 2: {new Decimal(packet.board3.counter.speedSignal2).toFixed(1)}
                                        </Typography>
                                        <Typography>
                                            Counter 3: {new Decimal(packet.board3.counter.speedSignal3).toFixed(1)}
                                        </Typography>
                                        <Typography>
                                            Counter 4: {new Decimal(packet.board3.counter.speedSignal4).toFixed(1)}
                                        </Typography>
                                    </Stack>
                                </TableCell>
                            </TableRow>
                            <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                <TableCell sx={Styles.carCell}>
                                    Coupling Relay No. 1 End
                                </TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    <GreenGreyLightIcon onOffBit={couplingRelayNo1End} onLabel="On" offLabel="Off" />
                                </TableCell>

                                <TableCell sx={Styles.carBorderCell}>
                                    Air Compressor Temperature Contact
                                </TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    <GreenRedLightIcon onOffBit={airCompressorTemperatureContact} onLabel="On" offLabel="Off" />
                                </TableCell>
                            </TableRow>
                            <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                <TableCell sx={Styles.carCell}>
                                    Coupling Relay No. 2 End
                                </TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    <GreenGreyLightIcon onOffBit={couplingRelayNo2End} onLabel="On" offLabel="Off" />
                                </TableCell>

                                <TableCell sx={Styles.carBorderCell}>
                                    Air Compressor Pressure Switch
                                </TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    <GreenRedLightIcon onOffBit={airCompressorPressureSwitch} onLabel="On" offLabel="Off" />
                                </TableCell>
                            </TableRow>
                            <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                <TableCell sx={Styles.carCell}>
                                    Brake Air Compressor Contactor
                                </TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    <GreenGreyLightIcon onOffBit={brakeAirCompressorContractor} onLabel="Operate" offLabel="Not Operate" />
                                </TableCell>

                                <TableCell sx={Styles.carBorderCell}>
                                    Air Compressor Thermal Overload
                                </TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    <GreenRedLightIcon onOffBit={airCompressorThermalOverload} onLabel="On" offLabel="Off" />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </>
    );
};

export default CarVccSystemTab;